// extracted by mini-css-extract-plugin
export default {"inputWrapper":"AdminSearch_inputWrapper__cHZrx","searchInput":"AdminSearch_searchInput__MkG05"};